var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282830",
    fillRule: "evenodd",
    d: "M6 2h8c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1m8 15.2a.2.2 0 0 0 .2-.2v-1.6H5.8V17c0 .11.09.2.2.2zm-8.2-2.6h8.4V4.4H5.8zm0-11h8.4V3a.2.2 0 0 0-.2-.2H6a.2.2 0 0 0-.2.2zm5.7 13.05h-3c-.22 0-.4-.18-.4-.4s.18-.4.4-.4h3c.22 0 .4.18.4.4s-.18.4-.4.4",
    clipRule: "evenodd"
  })));
};
export default SvgPhone;